const BASE_FONT_SIZE =  100;

export function getDocFontSize() {
  const computedStyle = document.defaultView.getComputedStyle(
    document.documentElement
  );

  return parseFloat(computedStyle.fontSize);
}

export function getRealHeight(size) {
  const realSize = (getDocFontSize() / BASE_FONT_SIZE) * size;

  return parseFloat(realSize);
}